const JobList = {
  ADMIN: 0,
  COMMERCIAL: 1,
  PRESCRIBER: 2,
  BUSINESS: 3,
  USER: 4,
  PRO: 5,
};

export default JobList;



// WEBPACK FOOTER //
// ./src/components/Protected/projet/jobList.js